<template>
  <div class="hero-badge" v-if="this.$whitelabel.heroBadge" v-bind:class="{'hero-badge--standalone': !this.$whitelabel.isStandalone}">
    <a v-if="this.$whitelabel.heroBadge.extUrl" class="hero-badge-link" :href="`${this.$whitelabel.heroBadge.extUrl}`" rel="noopener noreferrer" target="_blank">
      <img class="hero-badge-img" :src="`https://assets.urlaubsgutschein.kaufen${this.$whitelabel.assetUrl}/${this.$whitelabel.heroBadge.file}`" alt="" />
    </a>
    <img v-if="!this.$whitelabel.heroBadge.extUrl" class="hero-badge-img" :src="`https://assets.urlaubsgutschein.kaufen${this.$whitelabel.assetUrl}/${this.$whitelabel.heroBadge.file}`" alt="" />
  </div>
</template>

<script>
export default {
  name: 'HeroBadge',
  data() {
    return {}
  },

  methods: {},
}
</script>

<style lang="scss">
.hero-badge {
  flex-basis: 50%;
  display: block;
  @media screen and (min-width: 580px) {
    margin-left: 2rem;
  }
  @media screen and (min-width: 1216px) {
    position: absolute;
    right: 6rem;
    //top: 2rem;
  }
}

.hero-badge-link {
}

.hero-badge-img {
  width: min(40vw, 250px);
}

.hero-badge--standalone {
  position: absolute;
  right: 2rem;

  .hero-badge-img {
    width: min(20vw, 120px);
  }
}

@media screen and (max-width: 768px) {
  .hero-badge--standalone {
    display: none;
  }
}

@media screen and (max-width: 1023px) {
  .hero-badge--standalone {
    bottom: 0;
    right: 1rem;
  }
}
</style>
